import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsNotificationsRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-notifications',
	path: '/plugins/servlet/project-config/:projectKey/notifications',
};
